import type L from "leaflet";
import { BART_MAP_LINES, BART_MAP_STOPS } from "../bart-network";
import type { Coordinates } from "../../shared/types";

export function addBartNetwork(layers: L.LayerGroup, leaflet: typeof L): void {
	for (const line of BART_MAP_LINES) {
		if (line.paths.length) {
			leaflet.polyline(line.paths.flatMap((path, index) => (index ? path.slice(1) : path).map(point => [point.lat, point.lon] as L.LatLngTuple)), {
				color: line.color, weight: line.weight, opacity: line.opacity,
			}).addTo(layers);
		}
	}
	for (const station of BART_MAP_STOPS) {
		leaflet.circleMarker([station.lat, station.lon], {
			radius: station.radius, color: station.color, weight: station.weight, opacity: station.opacity,
			fillColor: station.fillColor, fillOpacity: station.fillOpacity,
		}).bindTooltip(station.name).addTo(layers);
	}
}

export function BartNetwork({ project }: { project: (lat: number, lon: number) => { x: number; y: number } }) {
	function points(path: readonly Coordinates[]) {
		return path.map(point => {
			const { x, y } = project(point.lat, point.lon);
			return `${x.toFixed(1)},${y.toFixed(1)}`;
		}).join(" ");
	}
	return <g aria-label="BART network">
		{BART_MAP_LINES.map(line =>
			<polyline key={line.id} data-bart-line={line.id} points={points(line.paths.flatMap((path, index) => index ? path.slice(1) : path))}
				fill="none" stroke={line.color} strokeWidth={line.weight} opacity={line.opacity}
				strokeLinecap="round" strokeLinejoin="round" />
		)}
		{BART_MAP_STOPS.map(station => {
			const { x, y } = project(station.lat, station.lon);
			return <circle key={station.id} data-bart-station={station.id} cx={x} cy={y} r={station.radius}
				stroke={station.color} strokeWidth={station.weight} strokeOpacity={station.opacity}
				fill={station.fillColor} fillOpacity={station.fillOpacity}>
				<title>{station.name}</title>
			</circle>;
		})}
	</g>;
}
